import { render, staticRenderFns } from "./AddPerson.vue?vue&type=template&id=19f61fbe&"
import script from "./AddPerson.vue?vue&type=script&lang=js&"
export * from "./AddPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports